import React, {useCallback, useMemo} from "react";
import {DragDropContext, Draggable, Droppable} from "@hello-pangea/dnd";

function DragDots() {
    return (
        <svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor" aria-hidden>
            <circle cx="4" cy="4" r="1.5" />
            <circle cx="12" cy="4" r="1.5" />
            <circle cx="4" cy="8" r="1.5" />
            <circle cx="12" cy="8" r="1.5" />
            <circle cx="4" cy="12" r="1.5" />
            <circle cx="12" cy="12" r="1.5" />
        </svg>
    );
}

export default function ApproveSelectedList({values, setValues}) {
    const sorted = useMemo(
        () => [...(values ?? [])].sort((a, b) => (a.orders ?? 0) - (b.orders ?? 0)),
        [values],
    );

    const handleRemove = (actorId) => {
        setValues((prev) => {
            const next = (prev ?? []).filter((v) => String(v.actor.id) !== String(actorId));
            return next.map((item, index) => ({...item, orders: index}));
        });
    };

    const handleDragEnd = useCallback(
        (result) => {
            if (!result.destination) return;
            if (result.source.index === result.destination.index) return;

            setValues((prev) => {
                const ordered = [...(prev ?? [])].sort((a, b) => (a.orders ?? 0) - (b.orders ?? 0));
                const [removed] = ordered.splice(result.source.index, 1);
                ordered.splice(result.destination.index, 0, removed);
                return ordered.map((item, index) => ({...item, orders: index}));
            });
        },
        [setValues],
    );

    if (sorted.length === 0) {
        return <div className="search-selector-empty">결재자를 선택해주세요</div>;
    }

    return (
        <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="approve-selected-list">
                {(provided) => (
                    <ul
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                        className="approve-modal__selected-list"
                    >
                        {sorted.map((item, index) => {
                            const draggableId = String(item.actor.id);

                            return (
                                <Draggable key={draggableId} draggableId={draggableId} index={index}>
                                    {(dragProvided, snapshot) => (
                                        <li
                                            ref={dragProvided.innerRef}
                                            {...dragProvided.draggableProps}
                                            className={[
                                                "approve-modal__selected-item",
                                                snapshot.isDragging ? "is-dragging" : "",
                                            ].filter(Boolean).join(" ")}
                                        >
                                            <span className="approve-modal__selected-order">
                                                {item.orders + 1}
                                            </span>
                                            <span
                                                className="approve-modal__selected-name"
                                                title={item.actor.name}
                                            >
                                                {item.actor.name}
                                            </span>
                                            <span
                                                className="approve-modal__selected-drag"
                                                {...dragProvided.dragHandleProps}
                                                aria-label="드래그하여 순서 변경"
                                            >
                                                <DragDots />
                                            </span>
                                            <button
                                                type="button"
                                                className="approve-modal__selected-remove"
                                                aria-label={`${item.actor.name} 제거`}
                                                onClick={() => handleRemove(item.actor.id)}
                                            >
                                                ×
                                            </button>
                                        </li>
                                    )}
                                </Draggable>
                            );
                        })}
                        {provided.placeholder}
                    </ul>
                )}
            </Droppable>
        </DragDropContext>
    );
}
